

<template>
	<li class="result-item">
		<div class="row">
			<div class="col-xs-9 title">
				<a href="#" @click.prevent.stop="selected">{{ result.title }}</a>
			</div>
			<div class="col-xs-3">
				{{ result.voicing }}
			</div>
		</div>
		<div class="row">
			<div class="col-xs-4">
				{{ result.composers }}
			</div>
			<div class="col-xs-5">
				{{ result.arrangers }}
			</div>
			<div class="col-xs-3">
				{{ result.numcopies }}
			</div>
		</div>
		<div class="row">
			<div class="col-xs-6">
				File ID: {{ result.file_id }}
			</div>
			<div class="col-xs-3">
				<!-- Reserved for Future Use -->
			</div>
			<div class="col-xs-3">
				{{ result.orchestration }}
			</div>
		</div>
	</li>
</template>

<script>
    export default {

    	props: ['result'],

    	methods: {
    		
			selected() {
				UWEvent.fire('resultSelected', this.result)
			},

    	}
    }


</script>

<style>
	.label {
		color: gray;
	}
</style>